import { create } from "zustand";
import { PeriodTypesEnum } from "../utils/enums/project";
import { FinanceTypeTable } from "../utils/enums/finance";

type StatisticStore = {
  period: string;
  setPeriod: (val: string) => void;
};

type ChartStatisticTypeStore = {
  type: string;
  setType: (val: string) => void;
};

export const useStatisticPeriod = create<StatisticStore>((set) => ({
  period: localStorage.getItem("statistic-period") || PeriodTypesEnum.WEEK,
  setPeriod: (val) => {
    localStorage.setItem("statistic-period", val);
    set({ period: val });
  },
}));

export const useChartStatisticType = create<ChartStatisticTypeStore>((set) => ({
  type: localStorage.getItem("chart-statistic-type") || FinanceTypeTable.INCOME,
  setType: (val) => {
    localStorage.setItem("chart-statistic-type", val);
    set({ type: val });
  },
}));
